import { OptionTypes } from '../types';
import isNumber from 'lodash/isnumber';

export const getFilterSelectedOptionsLength = (id: string, values: any, postfix?: string[], optionTypeValue?: OptionTypes) => {
  return [
    id,
    ...(!!postfix ? postfix.map(p => id + p) : [])
  ].reduce((sum, key) => {

    const hasValue = values && values[key] && values[key].hasOwnProperty('value');
    const value = hasValue && values[key].value;

    if (Array.isArray(value)) {
      return sum + value.length;
    }

    return sum + (hasValue && (!!value || isNumber(value)) ? 1 : 0);
  }, 0) + (optionTypeValue === OptionTypes.NotSpecified ? 1 : 0);
};
